import React from 'react'
import ChangePassword from './ChangePassword'

function Index(){
  return <ChangePassword />
}

export default Index
